export default {
	searchParams: SEARCH_PARAMS(),
	cpnyList: [],
	roNo: '',
	mtrlCst: '',
	dvswRt: '',
	aplDvswRt: '',
	rpymAmt: '',
	aplRpymAmt: '',
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		partNo: '',
		cpnyCd: '',
		partScn: 'PT',
		causPartNo: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
